"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bind_1 = require("./bind");
exports.bindResource = bind_1.bindResource;
var cache_1 = require("./cache");
exports.cacheResource = cache_1.cacheResource;
exports.invalidateResource = cache_1.invalidateResource;
exports.addOnInvalidateHandler = cache_1.addOnInvalidateHandler;
var observe_1 = require("./observe");
exports.observeResource = observe_1.observeResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/cache/index.js
// module id = 515
// module chunks = 0